"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    role: "search"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = { class: "sr-only" };
const _hoisted_4 = { class: "tw" };
const _hoisted_5 = {
    id: "searchHeadline",
    class: "sr-only"
};
const _hoisted_6 = { class: "relative" };
const vue_3 = require("vue");
const core_1 = require("@vueuse/core");
const vue_i18n_1 = require("vue-i18n");
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const SearchForm_vue_1 = __importDefault(require("./components/SearchForm.vue"));
const DepartmentToggle_vue_1 = __importDefault(require("./components/DepartmentToggle.vue"));
const CloseButton_vue_1 = __importDefault(require("@SharedVueComponents/CloseButton/CloseButton.vue"));
const services_inert_1 = require("@ocm/services/services.inert");
const use_search_1 = __importDefault(require("./composables/use-search"));
const use_scroll_behaviour_body_1 = __importDefault(require("./composables/use-scroll-behaviour-body"));
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const services_constants_1 = require("@ocm/services/services.constants");
const services_modal_1 = require("@ocm/services/services.modal");
const services_skipLinks_1 = require("@ocm/services/services.skipLinks");
const dataLayer_1 = require("./services/dataLayer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SearchApp',
    setup(__props) {
        const { t } = (0, vue_i18n_1.useI18n)();
        const OPEN_SEARCH_BUTTON_ID = services_skipLinks_1.skipLinks.search.rightDrawerButton.slice(1); // #open-search-right-drawer
        const isScreen1408px = (0, core_1.useBreakpoints)({ px1408: "88em" }).greaterOrEqual("px1408");
        const { userInput, isSearchVisible, openSearch, closeSearch, triggerSearch } = (0, use_search_1.default)();
        const searchAppEl = (0, vue_3.useTemplateRef)("searchAppEl");
        const searchDialogEl = (0, vue_3.useTemplateRef)("searchDialogEl");
        (0, core_1.onClickOutside)(searchAppEl, () => isScreen1408px.value && closeSearch());
        const searchBoxHeight = (0, vue_3.ref)("");
        const _setSearchBoxHeight = () => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            searchBoxHeight.value = `${window.visualViewport.height}px`;
        };
        const _resetSearchBoxHeight = () => {
            var _a;
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener("resize", _setSearchBoxHeight);
            searchBoxHeight.value = "";
        };
        const timeout = (0, vue_3.ref)();
        (0, vue_3.onBeforeUnmount)(() => {
            clearTimeout(timeout.value);
        });
        const isDrawerOpen = (0, vue_3.ref)(false);
        const openRightCanvas = () => {
            (0, dataLayer_1.tr_searchClick)("Icon");
            onOpenSearch();
        };
        const onOpenSearch = () => {
            // called by (this.)openRichtCanvas() and from outside using messenger: OPEN_SEARCH (left canvas)
            (0, services_inert_1.inertLandmarksAndSkipLinks)(searchDialogEl.value);
            openSearch();
            setAriaExpanded(true);
        };
        const searchSubmitted = (0, vue_3.ref)(false);
        const _onSearchSubmitted = () => {
            searchSubmitted.value = true;
        };
        const onCloseSearch = () => {
            (0, services_inert_1.removeInertFromLandmarksAndSkipLinks)();
            if (isScreen1408px.value)
                closeSearch();
            else {
                timeout.value = setTimeout(closeSearch, services_modal_1.animationDurationMs);
                // if user submitted a search request, focus will be handled in ResultAmount.vue
                if (isDrawerOpen.value && !searchSubmitted.value)
                    focusOpenSearchButton();
                isDrawerOpen.value = false;
                setAriaExpanded(false);
            }
            searchSubmitted.value = false;
        };
        function setAriaExpanded(value) {
            var _a, _b;
            (_a = document
                .querySelector(services_skipLinks_1.skipLinks.search.rightDrawerButton)) === null || _a === void 0 ? void 0 : _a.setAttribute("aria-expanded", `${value}`);
            (_b = document
                .querySelector(services_skipLinks_1.skipLinks.search.leftDrawerButton)) === null || _b === void 0 ? void 0 : _b.setAttribute("aria-expanded", `${value}`);
        }
        const { lockBody, unlockBody } = (0, use_scroll_behaviour_body_1.default)();
        (0, vue_3.watch)(isSearchVisible, async (isSearchVisible) => {
            var _a;
            if (isSearchVisible) {
                await (0, vue_3.nextTick)();
                if (!isScreen1408px.value) {
                    isDrawerOpen.value = true;
                    lockBody();
                }
                (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener("resize", _setSearchBoxHeight);
            }
            else {
                isDrawerOpen.value = false;
                unlockBody();
                _resetSearchBoxHeight();
            }
        });
        (0, vue_3.watch)(isScreen1408px, (isScreen1408px) => {
            if (!isSearchVisible.value)
                return;
            isDrawerOpen.value = !isScreen1408px;
            isScreen1408px ? unlockBody() : lockBody();
        });
        const onTriggerSearch = ({ data }) => {
            if (typeof data !== "string")
                return;
            userInput.value = data;
            triggerSearch();
        };
        const handleDialogEscapeKeyDown = () => {
            if (isSearchVisible.value) {
                onCloseSearch();
            }
        };
        const isScreenSmallerThan1024px = (0, core_1.useBreakpoints)({ px1024: "64em" }).smaller("px1024");
        const _skipLinkEl = document.querySelector("#js-skip-to-search");
        const _updateSkipLink = () => {
            if (!_skipLinkEl)
                return;
            switch (true) {
                case isScreenSmallerThan1024px.value:
                    _skipLinkEl.setAttribute("href", services_skipLinks_1.skipLinks.search.leftDrawerButton);
                    break;
                case isScreen1408px.value:
                    _skipLinkEl.setAttribute("href", services_skipLinks_1.skipLinks.search.input);
                    break;
                default:
                    _skipLinkEl.setAttribute("href", services_skipLinks_1.skipLinks.search.rightDrawerButton);
            }
        };
        (0, vue_3.onMounted)(() => {
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.OPEN_SEARCH, onOpenSearch);
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.SEARCH_SUBMITTED, _onSearchSubmitted);
            ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.CLOSE_SEARCH, onCloseSearch);
            if (document.querySelectorAll("[data-id=search]").length === 1) {
                ocm_mercurius_messenger_1.default.subscribe(services_constants_1.messengerPublicationTypes.TRIGGER_SEARCH, onTriggerSearch);
            }
            window.addEventListener("resize", _updateSkipLink);
            _updateSkipLink();
        });
        (0, vue_3.onUnmounted)(() => {
            _resetSearchBoxHeight();
            window.removeEventListener("resize", _updateSkipLink);
        });
        function focusOpenSearchButton() {
            var _a, _b;
            switch (true) {
                case isScreenSmallerThan1024px.value:
                    (_a = document.querySelector(services_skipLinks_1.skipLinks.search.leftDrawerButton)) === null || _a === void 0 ? void 0 : _a.focus();
                    break;
                case !isScreenSmallerThan1024px.value && !isScreen1408px.value:
                    (_b = document.querySelector(services_skipLinks_1.skipLinks.search.rightDrawerButton)) === null || _b === void 0 ? void 0 : _b.focus();
                    break;
            }
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "#header-search-container" }, [
                    (0, vue_2.createElementVNode)("div", {
                        ref_key: "searchAppEl",
                        ref: searchAppEl,
                        class: "tw",
                        "data-id": "search"
                    }, [
                        (!(0, vue_2.unref)(isScreen1408px))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                                (0, vue_2.createElementVNode)("button", {
                                    id: (0, vue_2.unref)(OPEN_SEARCH_BUTTON_ID),
                                    class: "flex h-11 scroll-mt-1.5 items-center justify-center px-3",
                                    "aria-haspopup": "dialog",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (openRightCanvas()))
                                }, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.search.openSearch")), 1),
                                    (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                        class: "size-5",
                                        "icon-name": "search"
                                    })
                                ], 8, _hoisted_2)
                            ]))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SearchForm_vue_1.default, { key: 1 }))
                    ], 512)
                ])),
                (!(0, vue_2.unref)(isScreen1408px))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, {
                        key: 0,
                        to: "body"
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["srh__drawer-overlay fixed left-0 top-0 z-[999] h-full w-screen justify-start desktop:justify-end", [(0, vue_2.unref)(isSearchVisible) ? 'flex' : 'hidden', { 'bg-black/70': isDrawerOpen.value }]]),
                                style: (0, vue_2.normalizeStyle)({ '--transition-duration': `${(0, vue_2.unref)(services_modal_1.animationDurationMs)}ms` }),
                                onClick: (0, vue_2.withModifiers)(onCloseSearch, ["self", "stop"])
                            }, [
                                (0, vue_2.createElementVNode)("div", {
                                    ref_key: "searchDialogEl",
                                    ref: searchDialogEl,
                                    role: "dialog",
                                    class: (0, vue_2.normalizeClass)(["srh__drawer flex max-h-full w-[35.7142857rem] max-w-full transform flex-col overflow-hidden overscroll-contain bg-white text-sm", { '-translate-x-full desktop:translate-x-full': !isDrawerOpen.value }]),
                                    style: (0, vue_2.normalizeStyle)({ height: searchBoxHeight.value }),
                                    "aria-modal": "true",
                                    "aria-labelledby": "searchHeadline",
                                    onKeydown: (0, vue_2.withKeys)(handleDialogEscapeKeyDown, ["escape"])
                                }, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("siteWide.searchApp.search.menuHeadline")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                        (0, vue_2.createVNode)(DepartmentToggle_vue_1.default),
                                        (0, vue_2.createVNode)(CloseButton_vue_1.default, {
                                            class: "right-4 top-2",
                                            onClick: onCloseSearch
                                        })
                                    ]),
                                    (0, vue_2.createVNode)(SearchForm_vue_1.default, { "in-drawer": "" })
                                ], 38)
                            ], 6)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
